import api from './api';

const inventoryService = {
  getInventories: async ({ page = 1, pageSize = 25 } = {}) => {
    try {
      const response = await api.get('/inventories', { params: { page, pageSize } });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  getInventoryById: async (inventoryId) => {
    try {
      const response = await api.get(`/inventories/${inventoryId}`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },


  getProductCost: async (productCode) => {
    const response = await api.post('/utils/getProductCost', { productCode });
    return response.data;
  },

  createInventory: async (inventoryData) => {
    try {
      if (inventoryData.csvFile) {
        const formData = new FormData();


        formData.append('inventoryName', inventoryData.inventoryName);
        formData.append('startDate', inventoryData.startDate);
        formData.append('endDate', inventoryData.endDate);


        formData.append('csvFile', inventoryData.csvFile);

        const response = await api.post('/inventories', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        return response.data;
      } else {
        const response = await api.post('/inventories', inventoryData);
        return response.data;
      }
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  createInventoryDetail: async (detailData) => {
    try {
      const response = await api.post('/inventories/details', detailData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  updateInventoryDetail: async (detailId, updateData) => {
    try {
      const response = await api.put(`/inventories/details/${detailId}`, updateData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  checkProduct: async (productCode) => {
    try {
      const response = await api.post('/utils/check', { productCode });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },


  getStock: async (params) => {
    try {
      const response = await api.post('/utils/stock', params);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  getShops: async () => {
    try {
      const response = await api.get('/utils/shops');
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  },

  getBarcodesByProductCodes: async (productCodes) => {
    try {
      const response = await api.post('/utils/barcodes', { productCodes });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error('Error de conexión');
    }
  }
};

export default inventoryService;